import React from 'react';
import { motion } from 'framer-motion';
import { Award, TrendingUp, Trophy, Gift } from 'lucide-react';
export function UserProgress() {
  // Simplified user data without login requirements
  const userData = {
    name: 'User',
    level: 2,
    points: 450,
    pointsToNextLevel: 1000,
    savingsTotal: '€125',
    couponsUsed: 8,
    nextReward: '€10 Anywhere Coupon',
    nextRewardPoints: 500,
    badges: [{
      name: 'Early Bird',
      earned: true
    }, {
      name: 'Smart Saver',
      earned: true
    }, {
      name: 'Loyal Fan',
      earned: false
    }]
  };
  const progressPercentage = userData.points / userData.pointsToNextLevel * 100;
  const nextRewardProgress = (userData.points - 0) / (userData.nextRewardPoints - 0) * 100;
  return <section data-id="element-420">
      <div className="bg-gray-900 rounded-xl text-white p-4" data-id="element-421">
        <div className="flex justify-between items-center mb-3" data-id="element-422">
          <div className="flex items-center" data-id="element-423">
            <div className="bg-white text-gray-900 rounded-full h-10 w-10 flex items-center justify-center font-bold text-lg mr-3" data-id="element-424">
              {userData.name.charAt(0)}
            </div>
            <div data-id="element-425">
              <h3 className="font-medium" data-id="element-426">Welcome!</h3>
              <div className="flex items-center text-xs" data-id="element-427">
                <Award className="h-3 w-3 mr-1" data-id="element-428" />
                <span data-id="element-429">Level {userData.level} Saver</span>
              </div>
            </div>
          </div>
          <div className="text-right" data-id="element-430">
            <div className="text-xl font-bold" data-id="element-431">{userData.savingsTotal}</div>
            <div className="text-xs opacity-80" data-id="element-432">Potential Savings</div>
          </div>
        </div>
        <div className="mb-4" data-id="element-433">
          <div className="flex justify-between text-xs mb-1" data-id="element-434">
            <span data-id="element-435">Level {userData.level}</span>
            <span data-id="element-436">Level {userData.level + 1}</span>
          </div>
          <div className="h-2 bg-white/20 rounded-full overflow-hidden" data-id="element-437">
            <motion.div className="h-full bg-white" initial={{
            width: 0
          }} animate={{
            width: `${progressPercentage}%`
          }} transition={{
            duration: 1,
            delay: 0.2
          }} data-id="element-438" />
          </div>
          <div className="flex justify-between text-xs mt-1" data-id="element-439">
            <span data-id="element-440">{userData.points} points</span>
            <span data-id="element-441">{userData.pointsToNextLevel} points</span>
          </div>
        </div>
        <div className="bg-white/20 rounded-lg p-3 backdrop-blur-sm" data-id="element-442">
          <div className="flex items-center justify-between mb-2" data-id="element-443">
            <div className="flex items-center" data-id="element-444">
              <Gift className="h-4 w-4 mr-2" data-id="element-445" />
              <span className="text-sm font-medium" data-id="element-446">
                Next Reward: {userData.nextReward}
              </span>
            </div>
            <span className="text-xs" data-id="element-447">
              {userData.nextRewardPoints - userData.points} points away
            </span>
          </div>
          <div className="h-2 bg-white/30 rounded-full overflow-hidden" data-id="element-448">
            <motion.div className="h-full bg-white" initial={{
            width: 0
          }} animate={{
            width: `${nextRewardProgress}%`
          }} transition={{
            duration: 1,
            delay: 0.4
          }} data-id="element-449" />
          </div>
        </div>
      </div>
      <div className="mt-4 grid grid-cols-3 gap-2" data-id="element-450">
        <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-451">
          <div className="text-lg font-bold text-gray-900" data-id="element-452">
            {userData.level}
          </div>
          <div className="text-xs text-gray-600" data-id="element-453">Level</div>
        </div>
        <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-454">
          <div className="text-lg font-bold text-gray-900" data-id="element-455">
            {userData.couponsUsed}
          </div>
          <div className="text-xs text-gray-600" data-id="element-456">Coupons Used</div>
        </div>
        <div className="bg-white rounded-lg p-3 text-center shadow-sm" data-id="element-457">
          <div className="text-lg font-bold text-gray-900" data-id="element-458">
            {userData.badges.filter(b => b.earned).length}
          </div>
          <div className="text-xs text-gray-600" data-id="element-459">Badges</div>
        </div>
      </div>
    </section>;
}